webpackJsonp([166995358864346],{

/***/ 69:
/***/ (function(module, exports) {

	module.exports = function (string) {
	  return string.charAt(0).toUpperCase() + string.substring(1);
	}
	
	module.exports.words = function (string) {
	  return string.replace(/(^|[^a-zA-Z\u00C0-\u017F'])([a-zA-Z\u00C0-\u017F])/g, function (m) {
	    return m.toUpperCase()
	  })
	}


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n@media (min-device-width:416px) and (orientation: portrait){\n  display:none;\n}\n'], ['\n@media (min-device-width:416px) and (orientation: portrait){\n  display:none;\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	var _Background = __webpack_require__(15);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundMobile = _Background2.default.extend(_templateObject);
	
	exports.default = BackgroundMobile;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n@media (max-device-width:417px) and (orientation: portrait){\n  display: block;\n}\n@media (min-device-width:2050px) and (orientation: portrait){\n  display:none;\n}\n'], ['\n@media (max-device-width:417px) and (orientation: portrait){\n  display: block;\n}\n@media (min-device-width:2050px) and (orientation: portrait){\n  display:none;\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	var _Background = __webpack_require__(15);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundTablet = _Background2.default.extend(_templateObject);
	
	exports.default = BackgroundTablet;
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n@media (min-device-width:0) and (orientation: landscape){\n  display: block;\n  color:green;\n}\n@media (min-device-width:0) and (orientation: portrait){\n  display:none;\n}\n'], ['\n@media (min-device-width:0) and (orientation: landscape){\n  display: block;\n  color:green;\n}\n@media (min-device-width:0) and (orientation: portrait){\n  display:none;\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	var _Background = __webpack_require__(15);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundWideScreen = _Background2.default.extend(_templateObject);
	
	exports.default = BackgroundWideScreen;
	module.exports = exports['default'];

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-weight: 400;\n  text-transform: capitalize;\n"], ["\n  color: ", ";\n  font-weight: 400;\n  text-transform: capitalize;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__(3);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Span = _styledComponents2.default.span(_templateObject, _presets2.default.brand);
	exports.default = Span;
	module.exports = exports["default"];

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BlogPostQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(14);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _capitalize = __webpack_require__(69);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _Section = __webpack_require__(26);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Background = __webpack_require__(15);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _BackgroundMobile = __webpack_require__(113);
	
	var _BackgroundMobile2 = _interopRequireDefault(_BackgroundMobile);
	
	var _BackgroundTablet = __webpack_require__(114);
	
	var _BackgroundTablet2 = _interopRequireDefault(_BackgroundTablet);
	
	var _BackgroundWideScreen = __webpack_require__(115);
	
	var _BackgroundWideScreen2 = _interopRequireDefault(_BackgroundWideScreen);
	
	var _Crosshairs = __webpack_require__(25);
	
	var _Crosshairs2 = _interopRequireDefault(_Crosshairs);
	
	var _Content = __webpack_require__(24);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Title = __webpack_require__(28);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Tag = __webpack_require__(27);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _P = __webpack_require__(46);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _Span = __webpack_require__(281);
	
	var _Span2 = _interopRequireDefault(_Span);
	
	var _Ul = __webpack_require__(66);
	
	var _Ul2 = _interopRequireDefault(_Ul);
	
	var _Cta = __webpack_require__(40);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _H = __webpack_require__(45);
	
	var _H2 = _interopRequireDefault(_H);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscribeMessage = "follow us";
	
	exports.default = function (_ref) {
	  var _React$createElement;
	
	  var data = _ref.data;
	
	  var post = data.seeYaml;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        (0, _capitalize2.default)(post.title),
	        ' | SUPERFRAME'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: (0, _capitalize2.default)(post.description) }),
	      _react2.default.createElement('meta', { property: 'og:title', content: (0, _capitalize2.default)(post.title) }),
	      _react2.default.createElement('meta', { property: 'og:description', content: '' + (0, _capitalize2.default)(post.description) }),
	      _react2.default.createElement('meta', { property: 'og:url', content: '' + data.site.siteMetadata.url + post.fields.slug }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'article' }),
	      _react2.default.createElement('meta', { property: 'og:image', content: '' + data.site.siteMetadata.url + post.image.publicURL }),
	      _react2.default.createElement('meta', { property: 'og:image:width', content: post.image.childImageSharp.original.width }),
	      _react2.default.createElement('meta', { property: 'og:image:height', content: post.image.childImageSharp.original.height }),
	      _react2.default.createElement('meta', { property: 'og:image:alt', content: post.title }),
	      _react2.default.createElement('meta', { property: 'og:image:secure_url', content: '' + data.site.siteMetadata.url + post.image.publicURL }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: data.site.siteMetadata.title }),
	      _react2.default.createElement('meta', { property: 'og:locale', content: 'en_GB' }),
	      _react2.default.createElement('meta', { property: 'og:locale:alternate', content: 'en_US' })
	    ),
	    post.video != null ? //checks to see if our yaml has a video entered or not.
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Section2.default,
	        null,
	        _react2.default.createElement(
	          _Background2.default,
	          null,
	          _react2.default.createElement(
	            'video',
	            (_React$createElement = { preload: 'auto', muted: 'true' }, _React$createElement['muted'] = true, _React$createElement.autoPlay = true, _React$createElement.loop = true, _React$createElement.playsInline = true, _React$createElement.poster = '', _React$createElement),
	            _react2.default.createElement('source', { src: post.video.publicURL, type: 'video/mp4' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Your browser does not support the video tag.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          null,
	          post.title != null ? _react2.default.createElement(
	            _H2.default,
	            { light: true },
	            post.title
	          ) : "",
	          _react2.default.createElement(
	            'p',
	            null,
	            post.date != null ? _react2.default.createElement(
	              _Span2.default,
	              null,
	              post.date
	            ) : "",
	            post.video != null ? _react2.default.createElement(
	              _Span2.default,
	              null,
	              ',\xA0[video]'
	            ) : ""
	          ),
	          post.description != null ? _react2.default.createElement(
	            _Tag2.default,
	            null,
	            post.description
	          ) : "",
	          post.client != null ? _react2.default.createElement(
	            _P2.default,
	            null,
	            'For ',
	            (0, _capitalize2.default)(post.client)
	          ) : "",
	          post.link != null ? _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: post.link, target: '_blank' },
	              post.link
	            )
	          ) : "",
	          _react2.default.createElement(
	            _Cta2.default,
	            { to: '/subscribe/' },
	            subscribeMessage
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        null,
	        _react2.default.createElement(
	          _BackgroundMobile2.default,
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: post.image.childImageSharp.mobile,
	            position: 'relative',
	            alt: post.title != null ? post.title : "",
	            style: {
	              height: '100vh'
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _BackgroundTablet2.default,
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: post.image.childImageSharp.tablet,
	            position: 'relative',
	            alt: post.title != null ? post.title : "",
	            style: {
	              height: '100vh'
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _BackgroundWideScreen2.default,
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: post.image.childImageSharp.widescreen,
	            position: 'relative',
	            alt: post.title != null ? post.title : "",
	            style: {
	              height: '100vh'
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _Content2.default,
	          null,
	          post.title != null ? _react2.default.createElement(
	            _H2.default,
	            { light: true },
	            post.title
	          ) : "",
	          _react2.default.createElement(
	            'p',
	            null,
	            post.date != null ? _react2.default.createElement(
	              _Span2.default,
	              null,
	              post.date
	            ) : ""
	          ),
	          post.description != null ? _react2.default.createElement(
	            _Tag2.default,
	            null,
	            post.description
	          ) : "",
	          post.client != null ? _react2.default.createElement(
	            _P2.default,
	            null,
	            'For ',
	            post.client
	          ) : "",
	          post.link != null ? _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: post.link, target: '_blank' },
	              post.link
	            )
	          ) : "",
	          _react2.default.createElement(
	            _Cta2.default,
	            { to: '/subscribe/' },
	            subscribeMessage
	          )
	        )
	      )
	    ) : // : << this means 'else'
	    // if there is no video, do this:
	    _react2.default.createElement(
	      _Section2.default,
	      null,
	      _react2.default.createElement(
	        _BackgroundMobile2.default,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: post.image.childImageSharp.mobile,
	          position: 'relative',
	          alt: post.title != null ? post.title : "",
	          style: {
	            height: '100vh'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _BackgroundTablet2.default,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: post.image.childImageSharp.tablet,
	          position: 'relative',
	          alt: post.title != null ? post.title : "",
	          style: {
	            height: '100vh'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _BackgroundWideScreen2.default,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: post.image.childImageSharp.widescreen,
	          position: 'relative',
	          alt: post.title != null ? post.title : "",
	          style: {
	            height: '100vh'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        post.title != null ? _react2.default.createElement(
	          _H2.default,
	          { light: true },
	          post.title
	        ) : "",
	        _react2.default.createElement(
	          'p',
	          null,
	          post.date != null ? _react2.default.createElement(
	            _Span2.default,
	            null,
	            post.date
	          ) : ""
	        ),
	        post.description != null ? _react2.default.createElement(
	          _Tag2.default,
	          null,
	          post.description
	        ) : "",
	        post.client != null ? _react2.default.createElement(
	          _P2.default,
	          null,
	          'For ',
	          post.client
	        ) : "",
	        post.link != null ? _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: post.link, target: '_blank' },
	            post.link
	          )
	        ) : "",
	        _react2.default.createElement(
	          _Cta2.default,
	          { to: '/subscribe/' },
	          subscribeMessage
	        )
	      )
	    )
	  ); //end return
	}; //end export default
	
	var BlogPostQuery = exports.BlogPostQuery = '** extracted graphql fragment **';
	// I have adjusted the queries about to work only for a portrait mobile phone screen, providing retina imagery.

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-see-post-responsive-js-d6b2b647be9cb75dc644.js